import React, { Component } from 'react';
import Slider from "react-slick";
import AiOptionButtonWrap from './AiOptionButtonWrap';
import {OPTION_URL} from '../constants';


function NextArrow(props) {
  const { className, onClick } = props;
  return (
    <div
      className={className +' fa ai-next-arrow ai-fcolor-' + window.currentSite }
      onClick={onClick}
    />
  );
}
function PrevArrow(props) {
  const { className,  onClick } = props;
  return (
    <div
      className={className +' fa ai-prev-arrow ai-fcolor-' + window.currentSite }
      onClick={onClick}
    />
  );
}


class AiOption extends Component {
    // extends React.Component {
  render() {
    //console.log('render-aioption',this.props)
    var settings = {
      dots: false,
      infinite: false,
      speed: 500,
      //lazyLoad: true,
      slidesToShow: this.props.optionNumber,
      slidesToScroll: this.props.optionNumber,
      arrow:true,
      initialSlide:0,
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />,  
      className:'ai-options'
//      adaptiveHeight: true

    };
    //console.log('render-aioption',this.props.optionSize)
    var optionSize = this.props.optionSize +'px';
    let rows = [];
    var children = this.props.children
    for (let i in children) {
      //console.log('not last',this.props.image_postfix1,this.props)
      //if (this.props.image_postfix1 !== undefined)
      //console.log('not last2',this.props.image_postfix1[0].shape)
      var dyn_postfix =this.props.image_postfix
      if (this.props.image_postfix1 !== undefined)
        //console.log('not last2',this.props.image_postfix1[0].shape)
        dyn_postfix =this.props.image_postfix1[0].shape
      let image_url = OPTION_URL  
      let image_url2 = OPTION_URL  
      image_url += 'small/'
      image_url2 += 'large/'
      if (['9329','9355'].includes(this.props.acharm) && this.props.image_base === 'letter'){
        image_url += 'charms/i'+this.props.acharm +"/"
        image_url2 += 'charms/i'+this.props.acharm +"/"
        
      }
      else {
      image_url += this.props.image_base +"/"
      image_url2 += this.props.image_base +"/"
      }
      if (this.props.image_postfix !== ''){
        image_url += dyn_postfix +'/'
        image_url2 += dyn_postfix +'/'
      }  
      image_url += children[i].image
      image_url2 += children[i].image
    //  console.log('new setting',this.props)
    
      if (children[i].value === this.props.initialValue) 
        if (parseInt(i,10) >this.props.optionNumber) {
          settings.initialSlide = parseInt(i,10) -this.props.optionNumber + 1
  //        console.log('new setting',i,settings.initialSlide,children[i].attr)
        }
      //if (children[i].show)
      var active_view = false
      if (this.props.hasOwnProperty('active_view')) {
        active_view = this.props.active_view
      //  active_view = children[i].active_view
      }
   //   else if (ALL_STONES.indexOf(this.props.attr) !== -1) {
   //     active_view ='1'
   //   }
      //console.log ('AIOPTION',this.props.attr,active_view,this.props)
      let prefix=undefined
      if (children[i].quality === 'L') {
        if (children[i].value === 'd') {
            prefix='Lab-Grown'
        }
        else {
            prefix='Lab-Created'
        }
      }
      if (children[i].quality === 'N') {
        prefix='Genuine'
      }
      if (children[i].quality === 'Round') {
        prefix='Round'
      }
      if (children[i].value === 'spy') {
        prefix='10K Gold Plated'
      }
      if (children[i].value === 'spr') {
        prefix='10K Gold Plated'
      }
      
      let name_top=''

      if (children[i].hasOwnProperty('month')) {
          name_top = children[i].month.substring(0,3).toUpperCase()
      }
// block blue topaz
      //if (children[i].value !== 'bt')
   //   console.log('AIOPTION name',this.props.optionName)
      //if (children[i].hasOwnProperty('show'))
       if (children[i].show !== false)
      
      rows.push(<AiOptionButtonWrap 
        name={children[i].name} 
        nameTop={name_top} 
        namePrefix={prefix} 
        attr={this.props.attr} 
        value={children[i].value} 
        active_view ={active_view}
        key={this.props.attr +'-'+i.toString()} 
        style={{ float:'left',height:optionSize}}
        image={image_url}
        image2={image_url2}
        optionTitle={this.props.name.toUpperCase()}
        options_all={this.props.options_all}
        optionsName={this.props.optionName}
        optionNumber={this.props.optionNumber} 
        sizeName={this.props.sizeName}
            
            

        optionSize={optionSize} />);
    }
    let hr_not_last =[]
    if (this.props.last === 'false') {
      hr_not_last.push(<div className='ai-br' key={this.props.attr +'--hr'} />)
      
    }
   
    var note = ''
    if (this.props.attr === 'f') {
    note =<div className='ai-input-box-bottom'>
    <div className='ai-br'/>
    NOTE: Personalization options do not support the use of emoji or symbols. Our experts will ensure the proper size and placement of your message.
    </div> 
    }
   // var sliderSize = (rows.length * this.props.optionSize) +'px';
    var maxSliderSize = (this.props.optionNumber * this.props.optionSize+3) +'px';
    //console.log('max',maxSliderSize);
    let fcolor ='ai-color-' + window.currentSite  +' ai-option-title ai-option-title-'+ window.currentSite


   if (rows.length<= this.props.optionNumber)
    return (
     <div  style={{width:maxSliderSize,marginLeft:'30px'}} className={'ai-option-box' + this.props.optionName + ' ai_option_'+this.props.attr}>
      <div><div className={fcolor}>{this.props.name.toUpperCase()}</div></div>
      {rows}
      <div style={{clear:'both'}}/>
      {note}
      {hr_not_last}
    </div>
    );
   else     
    return (
      <div  style={{width:maxSliderSize,marginLeft:'30px'}} className={'ai-option-box' + this.props.optionName}>
      <div><div className={fcolor}>{this.props.name.toUpperCase()}</div></div>
        <Slider {...settings} style={{width:maxSliderSize,height:optionSize}}>
        {rows}
        </Slider>
        {note}
        {hr_not_last}
      </div>
    
    );
  }
}
export default AiOption;


// WEBPACK FOOTER //
// ./src/layout/AiOption.js